export default __webpack_public_path__ + "static/media/fulllogo.5606a0a6.jpg";